import { SxProps } from "@mui/material";

import PlaybackOverlay, {
  PlaybackOverlayButton,
} from "@app/analytics/components/PlaybackOverlay";

import { Thumbnail } from "./styles";

interface IconVideoThumbnailProps {
  thumbnailUrl?: string | null;
  state: "available" | "unavailable" | "locked";
  loading?: boolean;
  sx?: SxProps;
}

const IconVideoThumbnail = ({
  thumbnailUrl,
  loading = false,
  state,
  sx,
}: IconVideoThumbnailProps) => (
  <>
    <Thumbnail
      sx={{
        ...sx,
        backgroundImage: thumbnailUrl ? `url("${thumbnailUrl}")` : undefined,
      }}
    >
      <PlaybackOverlay>
        <PlaybackOverlayButton
          icon={loading ? "play" : state === "locked" ? "lock" : "no_video"}
        />
      </PlaybackOverlay>
    </Thumbnail>
  </>
);

export default IconVideoThumbnail;
